import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { CorVeiculoService } from '../services/cor-veiculo.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-cores-veiculo-edit',
	templateUrl: './cores-veiculo-edit.component.html',
	styleUrls: ['./cores-veiculo-edit.component.css'],
	animations: [loadingFade]
})

export class CoresVeiculoEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public cor_veiculo_id = null;

	public formCorVeiculo: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private corVeiculoSvc: CorVeiculoService,
				private router: Router) { }

	ngOnInit() {
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.cor_veiculo_id = params.id;
				// pega dados a partir do id
				this.corVeiculoSvc.getCorVeiculo(params.id).then((data: any) => {
					this.preencheForm({
						cor_veiculo_id: data.cor_veiculo_id,
						cor_veiculo_nome: data.cor_veiculo_nome,
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formCorVeiculo = this.fb.group({
			cor_veiculo_id: null,
			cor_veiculo_nome: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formCorVeiculo.setValue(dados);
	}

	enviaCorVeiculo() {
		if (this.formCorVeiculo.valid) {
			this.submitting = true;

			let toSend = this.formCorVeiculo.value;

			if (this.cor_veiculo_id === null) { // criar
				this.corVeiculoSvc.criaCorVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Cor criada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/coresveiculo']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.corVeiculoSvc.editaCorVeiculo(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Cor alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/coresveiculo']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formCorVeiculo.controls){
				let campo = this.formCorVeiculo.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formCorVeiculo.get(nome);
		return input.touched && input.invalid;
	}
}
